import React, { Component } from 'react';
import './Schedule.css'
import GoPremium from '../../../../components/go-premium/GoPremium'

class Schedule extends Component {

    constructor(props) {
        super(props)
        this.state = {
            hours: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12",
                    "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"
                    ],
            open: false
                
        }
    }

    goPremium = () => {
        this.setState({open: true})
    }

    handleClose = () => {
        this.setState({open: false})
    }

    render() {
        return (
            <section>
                <h1>Premium</h1>
                <div className="schedule-container" onClick={this.goPremium}>
                    <div className="schedule-background row">
                        {this.state.hours.map(
                            (value, index) => (
                                <div className="schedule-hour-container" key={index}>
                                    {index}
                                </div>
                            ))}
                    </div>
                    <div className="schedule-playlists">
                        {this.props.device.playlists && this.props.device.playlists.objects.filter((e) => e.selected).slice(0, 6).map((playlist) => 
                            <div className="schedule-playlist" key={playlist.dbid.id}>
                                {playlist.name}
                            </div>
                        )}
                    </div>
                </div>
                <div className="restriction-detail">Horarios en los que se activarán tus playlists</div>
                <GoPremium open={this.state.open} onRequestClose={this.handleClose}/>                    
            </section>
            );
    }
}

export default Schedule;


// WEBPACK FOOTER //
// ./src/pages/home/sections/schedule/Schedule.js